import { Target, Eye, Award } from "lucide-react";

export default function About() {
  return (
    <div>
      <section className="bg-[#0A2540] text-white py-20">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-sm font-semibold tracking-wide uppercase text-orange-400 mb-3">About us</div>
          <h1 className="text-4xl lg:text-6xl font-display font-extrabold max-w-3xl leading-tight">Victoria's most trusted White Card provider.</h1>
          <p className="mt-6 max-w-2xl text-lg text-slate-300">We've trained over 2,800 construction workers across Melbourne since 2018 - with a 97% same-day pass rate and a review score of 4.9/5.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 py-20 grid md:grid-cols-2 gap-12">
        <div className="wc-card p-8">
          <div className="w-11 h-11 rounded-lg bg-orange-100 text-orange-600 flex items-center justify-center mb-4"><Target className="w-5 h-5" /></div>
          <h2 className="text-2xl font-display font-extrabold text-[#0A2540] mb-3">Our mission</h2>
          <p className="text-slate-600 leading-relaxed">To make workplace safety training in the Australian construction industry accessible, engaging, and genuinely useful - not just a box-tick.</p>
        </div>
        <div className="wc-card p-8">
          <div className="w-11 h-11 rounded-lg bg-orange-100 text-orange-600 flex items-center justify-center mb-4"><Eye className="w-5 h-5" /></div>
          <h2 className="text-2xl font-display font-extrabold text-[#0A2540] mb-3">Our vision</h2>
          <p className="text-slate-600 leading-relaxed">Zero preventable incidents on Australian construction sites - starting with the very first shift.</p>
        </div>
      </section>

      <section className="bg-slate-50 py-20 border-y border-slate-200">
        <div className="max-w-7xl mx-auto px-4">
          <div className="max-w-2xl mb-10">
            <div className="text-sm font-semibold tracking-wide uppercase text-orange-600 mb-2">Accreditation</div>
            <h2 className="text-3xl lg:text-4xl font-display font-extrabold text-[#0A2540]">Fully accredited and compliant</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-4">
            <div className="wc-card"><Award className="w-8 h-8 text-orange-500 mb-3" /><div className="font-display font-extrabold text-[#0A2540]">RTO #45698</div><p className="text-sm text-slate-600 mt-1">Registered Training Organisation on the National VET Register.</p></div>
            <div className="wc-card"><Award className="w-8 h-8 text-orange-500 mb-3" /><div className="font-display font-extrabold text-[#0A2540]">WorkSafe VIC</div><p className="text-sm text-slate-600 mt-1">Approved to deliver CPCWHS1001 across Victoria.</p></div>
            <div className="wc-card"><Award className="w-8 h-8 text-orange-500 mb-3" /><div className="font-display font-extrabold text-[#0A2540]">ASQA compliant</div><p className="text-sm text-slate-600 mt-1">Fully compliant with Australian Skills Quality Authority standards.</p></div>
          </div>
        </div>
      </section>
    </div>
  );
}
